import { SET_NUDGE, SET_NUDGE_SUCCESS } from "./actionTypes";

const initState = {
  nudge: undefined,
};

export const actions = {
  setNudge(nudge) {
    return {
      type: SET_NUDGE,
      payload: nudge,
    };
  },
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case SET_NUDGE: {
      return {
        ...state,
        nudge: action.payload,
      };
    }
    case SET_NUDGE_SUCCESS: {
      return initState;
    }

    default:
      return state;
  }
};
reducer.initialState = initState;
export default reducer;
